/**
 * Strip HTML tags + decode common entities for notification rendering.
 * Mirrors backend stripHtml in enhanced-notification.service.ts so both
 * layers produce identical plaintext.
 *
 * Defense in depth: backend strips before persisting (R30-001 primary fix);
 * frontend strips before storing into the in-memory notification feed so
 * pre-fix DB rows and any future regressions cannot leak HTML into the UI.
 */
export function stripHtml(input: string | undefined | null): string {
  if (!input) return '';
  return (
    input
      // Only match true tag-shaped patterns: <tag>, </tag>, <tag attr="...">,
      // <tag\n...>, etc. Requires a letter (optionally preceded by /) right
      // after the `<` so bare comparisons like "Price < 100" are preserved.
      .replace(/<\/?[a-zA-Z][^>]*>/g, ' ')
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/\s{2,}/g, ' ')
      .trim()
  );
}
